import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'

import { getParsedDate, useParsedWeekday } from 'utils/dateParser'
import { useTranslation } from 'language/translator'
import { useWelcomeTitle } from './utils'

interface HomeHeaderProps {
  sx?: SxProps
}

const HomeHeader = (props: HomeHeaderProps) => {
  const { sx } = props

  const { t, lang } = useTranslation()

  const title = useWelcomeTitle()

  const today = new Date()
  const date = getParsedDate(today, lang)
  const weekday = useParsedWeekday()

  return (
    <>
      <Box sx={sx}>
        <Text component="h1" variant="h4">
          {title}
        </Text>
        <Text color="text.secondary" variant="body1">
          {t('home', 'updated_stats_for') + ' '}
          <b>
            {weekday} {date}
          </b>
          .
        </Text>
      </Box>
    </>
  )
}

export default HomeHeader
